// Prod Settings
export const environment = {
  version: 'https://o3qafb.o3ozone.ai/assets/js/version.json',
  production: true,
  O3CoreApiUrl: 'https://o3ozone-qa-gatewayapi.azurewebsites.net/api/',
  workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
  blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
  companyKey: '214604B3-057B-4AC1-A4EB-8CA98AB2DAD9', //o3 manufacturing
  LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbot',
  api_version: 'v1.0.0',
  white_listed_Domains: [
    'https://o3ozone-qa-gatewayapi.azurewebsites.net/'
  ],
  api_baseurl: 'https://o3ozone-qa-gatewayapi.azurewebsites.net/',
  api_signalR_baseUrl: 'https://oig-uat-auth-api.azurewebsites.net/',
  api_baseurlUty: 'https://oig-uat-gateway-api.azurewebsites.net/api/',
  api_prefix: 'api/',
  core_app_url: 'https://o3qa.o3ozone.ai/login',
  lean_app_url: 'https://o3qalean.o3ozone.ai/login',
  utility_app_url: 'https://o3-cloud-saned-angular.azurewebsites.net/login',
  NotificationUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
  firebaseConfig: {
    apiKey: "AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4",
    authDomain: "o3-push-notification.firebaseapp.com",
    projectId: "o3-push-notification",
    storageBucket: "o3-push-notification.appspot.com",
    messagingSenderId: "372705983827",
    appId: "1:372705983827:web:ce7c5df94e807d28ee35a6",
    vapidKey: 'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI'
  }
}

//  "O3CoreApiUrl": "#{O3_CORE_API_URL}#",
